module.exports = __webpack_public_path__ + "static/media/steins.c0b546f6.jpg";